import moment from 'moment';

export const getOriginalQuote = state => state.original_quote;
